import accessRadarMark from "@/assets/access-radar-mark.svg";

export default function AccessLogoBrand() {
  return (
    <div className="access-brand" aria-label="Radar by Iberdrola">
      <img
        src={accessRadarMark}
        alt=""
        className="access-brand__logo"
        width={64}
        height={64}
        decoding="async"
      />
    </div>
  );
}
